import { createSlice } from '@reduxjs/toolkit';
import { SiteState } from './state';
import reducers from './reducers';

const initialState: SiteState = {
  faqs: null,
  terms: null,
  rent_place: null,
  company_history: null,
  media_news: null,
  introduction: null,
};

const site = createSlice({
  name: 'site',
  initialState,
  reducers,
});

export const siteActions = { ...site.actions };
export default site;
